import React from 'react';
import { Search as SearchIcon } from 'lucide-react';
import EmptyState from '../../../../components/common/EmptyState';

interface EmptyNoFilterMatchProps {
  onReset: () => void;
}

export default function EmptyNoFilterMatch({ onReset }: EmptyNoFilterMatchProps) {
  return (
    <EmptyState
      icon={<SearchIcon size={48} strokeWidth={1.75} />}
      title="No cleanups match these filters"
      description="Try a wider date range or clear a filter to see more."
      secondaryAction={{
        label: 'Reset filters',
        onClick: onReset,
      }}
    />
  );
}